/* global axios */
import ApiClient from './ApiClient';

// Knowledge brain admin (A1c) — manage the shared corpus's sources + trigger ingestion.
class KnowledgeSourcesAPI extends ApiClient {
  constructor() {
    super('knowledge/sources', { accountScoped: true });
  }

  ingest(id) {
    return axios.post(`${this.url}/${id}/ingest`);
  }
}

export default new KnowledgeSourcesAPI();
